import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appMarketingMenuHeaderInflatorContainer]',
  standalone: false
})
export class MarketingMenuHeaderInflatorContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
